<template>
    <div class="wrapper">
        <div class="anew" @click="$router.go(-1)"></div>
        <div class="title">我的奖品</div>
        <div class="prizeBox">
            <div class="elements" v-show="drawList.length == 0"></div>
            <div class="list" v-show="drawList.length>0">
               
                <div class="item" v-for="(item,index) in drawList" :key="index">
                    <div class="icon">
                        <div v-show="item.prizeId == 3" class="identification">农行专属</div>
                        <img :src="item.url" alt="">
                    </div>
                    <div>
                        <div class="text">{{ item.name }}</div>
                        <div class="introduce">{{ item.tips }}</div>
                        <div v-show="item.prizeId == 3" class="tips">中国农业银行APP专属</div>
                    </div>
                        
                    <div class="pick-bt" @click="jump(item)"></div>
                </div>
                
            </div>
        </div>
        <codePop ref="codePop" :selectModel="selectModel" :text="codeUrl" />
    </div>
</template>

<script>
import codePop from './codePop.vue'
import { getPrize } from '@/api'
import { CityBridge } from '@/assets/js/js-bridge'

export default {
    components: {
        codePop
    },
    props: {},
    data() {
        return {
            codeUrl:'',
            drawList:[],
            selectModel:{},
            prizeImg:[{
                id:1,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/prizes3.png',
            },{
                id:2,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/nh.png',
            },{
                id:3,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },{
                id:4,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:5,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:6,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:7,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:8,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:9,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:10,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:11,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:12,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:13,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:14,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:15,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            }],
        }
    },
    watch: {},
    computed: {},
    methods: {
        jump(item){
            if(item.exchangeType == 2){
                this.$refs.codePop.show = true
                this.selectModel = item
                return
            }
            let link = item.link
            this.$ixmWebView(link)
            // let applicationType = ''  //渠道：1->APP；2->市民卡；3->PC；4->公众号
            // let ua = navigator.userAgent.toLowerCase()
            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //     applicationType = 4
            // } else if (ua.match(/xmsmk/i) == "xmsmk") {
            //     applicationType = 2
            // } else {
            //     applicationType = 1
            // } 
            // if (link.indexOf('APP:') != -1) {
            //     location.href = 'https://wx.abchina.com/webank/main-view/h5ForKED?id=93OUPeUcoCo%3D'
            // }else{
            //     if(applicationType == 2){
            //         var uas = navigator.userAgent;
            //         let preloadJs = function() {
            //         // Promise语法是ES6⽀持的，其他不⽀持的请⾃⾏转成ES5
            //         return new Promise((resolve, rejct) => {
            //             if (uas.toLowerCase().indexOf("xmsmk") !== -1) {
            //             if (window.UmsApi === undefined) {
            //                 document.addEventListener(
            //                 "OnUmsApiReady",
            //                 function() {
            //                     resolve(true);
            //                 },
            //                 false
            //                 );
            //             } else {
            //                 resolve(true);
            //             }
            //             } else {
            //             // ⾮市⺠卡接⼊
            //             reject("⾮市⺠卡接⼊");
            //             }
            //         });
            //         };
            //         preloadJs().then(res=>{
            //             var url = link.split('LINK:')[1]
            //             UmsApi.system.openWebPage.bySelf(url)

            //         })

            //     } else if(applicationType == 1){
            //         CityBridge.openWindow({
            //             url:link.split('LINK:')[1]
            //         })
            //     }

            // }

        },
        pick(item){
            if(item.exchangeType == 2){
                this.$refs.codePop.show = true
                this.selectModel = item
            }else{
                console.log(item)
                var ua = navigator.userAgent;
                let preloadJs = function() {
                // Promise语法是ES6⽀持的，其他不⽀持的请⾃⾏转成ES5
                return new Promise((resolve, rejct) => {
                    if (ua.toLowerCase().indexOf("xmsmk") !== -1) {
                    if (window.UmsApi === undefined) {
                        document.addEventListener(
                        "OnUmsApiReady",
                        function() {
                            resolve(true);
                        },
                        false
                        );
                    } else {
                        resolve(true);
                    }
                    } else {
                    // ⾮市⺠卡接⼊
                    reject("⾮市⺠卡接⼊");
                    }
                });
                };
                preloadJs().then(res=>{
                    var url = item.link
                    UmsApi.system.openWebPage.bySelf(url)

                })
            }
        },
        getPrize(){
            this.$toast.loading({
                duration: 0,
                forbidClick: true
            })
            getPrize().then(res=>{
                let data = res.data.data
                data.forEach(ele=>{
                    this.prizeImg.forEach(item=>{
                        if(ele.prizeId == item.id){
                            this.drawList.push({
                                ...ele,
                                link:ele.url,
                                url:item.url
                            })
                        }
                        
                    })
                    
                })
                // this.drawList.unshift({
                //     url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/prizes3.png',
                //     name:'222'
                // })
                console.log(this.drawList)
            }).finally(() => {
                this.$toast.clear()
            });
        }
    },
    created() { 
        this.codeUrl ='2020122440'
        this.getPrize()
    },
    mounted() { }
}
</script>
<style scoped lang="scss">
.wrapper {
    width: 100vw;
    height: 100vh;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(180deg, #4DAEFF 0%, #E1F9FA 52%, #FFEDCB 100%);
}
.anew{
    width: 1.95rem;
    height: .51rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/home.png);
    margin-top: .58rem;
}
.title{
    width: 100%;
    height: .77rem;
    font-size: .65rem;
    text-align: center;
    margin-top: .75rem;
    color: #fff;
    font-family: DingTalkJinBuTi;
}
.prizeBox{
    width: 6.94rem;
    height: 78vh;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/prizeBox.png);
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    .elements{
        width: 2.81rem;
        height: 3.34rem;
        background-size: 100% auto;
        background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/elements.png);
        position: absolute;
        top: 3rem;
    }
    .list{
        width: 6.08rem;
        height: 74vh;
        overflow-y: scroll;
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .item{
            width: 6.08rem;
            min-height: 2.4rem;
            display: flex;
            align-items: center;
            border-top: .02rem solid rgba(211, 211, 211, 0.77);
                .tips{
                    width: 2.44rem;
                    height: .35rem;
                    line-height: .35rem;
                    color: #9D9D9D;
                    font-size: .24rem;
                    margin-top: .16rem;
                    margin-left: .14rem;
                    
                }

                .pick-bt{
                    min-width: 1.96rem;
                    height: 1rem;
                    background-size: 100% auto;
                    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/pick-bt.png);
                    margin-left: .14rem;
                    background-position: top;
                    background-repeat: no-repeat;
                }

            .icon{
                min-width: 1.54rem;
                height: 1.54rem;
                position: relative;
                display: flex;
                justify-content: center;
                .identification{
                    width: 1.05rem;
                    height: .3rem;
                    line-height: .3rem;
                    border-radius: .3rem;
                    background-color: #399789;
                    color: #fff;
                    font-size: .21rem;
                    text-align: center;
                    font-family: SourceHanSansCNMedium;
                    position: absolute;
                    top: -.15rem;
                }
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .text{
                width: 2.21rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #194769;
                font-family: DingTalkJinBuTi;
                font-size: .33rem;
                margin-left: .23rem;
            }
            .introduce{
                width: 2.21rem;
                font-size: .33rem;
                color: #194769;
                font-family: DingTalkJinBuTi;
                margin-left: .23rem;
            }
        }
        .item:nth-child(1){
            border:none
        }
    }
}
</style>